import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { ProductCollectionOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';

import { GetStartedText } from '../components/get-started-heading';
import { Headings } from '../components/headings';
import { FreeToGetStartedText } from '../components/sub-heading';
import { InputSubmitButton } from '../components/submit-input';

export const ProductCollectionLoggedOut = () => (
	<ProductCollectionOverlayTemplate size="sm">
		<Headings
			main={<GetStartedText productName="Product Collection" />}
			sub={<FreeToGetStartedText />}
		/>
		<AccountCreation Input={<InputSubmitButton />} Submit={null} />
	</ProductCollectionOverlayTemplate>
);
